import collection from "@/store/collection.store-partial";
import trickModule from "@/store/game/tricks/single.store";

export default {
	namespaced: true,
	modules: {
		collection,
	},
	getters: {
		owned: (state, getters) => getters.array.filter((trick) => trick.owned),
		selected: (state, getters) => getters.array.filter((trick) => trick.selected),
		bySlot: (state, getters) => (slot) => getters.ordered.filter(
			(trick) => trick.performance_slot === slot.id
		),
	},
	actions: {
		configureApp: {
			root: true,
			async handler({ dispatch }, configData) {
				await dispatch("populate", {
					items: configData.tricks,
					path: ["game", "tricks"],
					module: trickModule,
				});
			},
		},
		purchase({ getters, dispatch, rootGetters }) {
			const fund = rootGetters["game/funds/spendable"];
			getters.selected.forEach((trick) => {
				dispatch(`${trick.id}/purchase`, fund);
			});
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/tricks/list.store.js